// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { PLANTING_STATUS } from '@seedplanner/shared-utils';

interface PlantingData {
  readonly planting_time: number;
  readonly planting_status: string;
}

export function groupPlantingsByTime<T extends PlantingData>(plantings: T[]) {
  const groupedPlantings = plantings.reduce((acc, planting) => {
    const key = planting.planting_time;
    const maybeCurrentGroup = acc.get(key);
    if (maybeCurrentGroup === undefined) {
      acc.set(key, {
        time: planting.planting_time,
        isCompleted:
          // planting.planting_status === PLANTING_STATUS.COMPLETED || planting.planting_status === PLANTING_STATUS.CANCELLED,
          planting.planting_status === PLANTING_STATUS.COMPLETED,
        plantings: [planting],
      });
    } else {
      const existingStatus = maybeCurrentGroup.isCompleted;
      const existingHarvests = maybeCurrentGroup.plantings;
      // If status is planned or in progress, then keep isCompleted will be false
      // If status is completed or cancelled, then isCompleted is true only if the existing status is true as well
      const isCompleted = existingStatus && planting.planting_status === PLANTING_STATUS.COMPLETED;
      // (planting.planting_status === PLANTING_STATUS.COMPLETED || planting.planting_status === PLANTING_STATUS.CANCELLED);
      acc.set(key, { isCompleted, time: planting.planting_time, plantings: [planting, ...existingHarvests] });
    }

    return acc;
  }, new Map<number, { isCompleted: boolean; time: number; plantings: T[] }>());

  return groupedPlantings;
}
